// src/hooks/useThumbnailUploader.js
import { useCallback } from 'react'
import captureThumbnail from '../utils/captureThumbnail.js'

export default function useThumbnailUploader(chatId, iframeRef, loading) {
  const onIframeLoad = useCallback(async () => {
    if (!iframeRef.current || loading) return

    try {
      const dataUrl = await captureThumbnail(iframeRef.current)
      if (dataUrl && chatId) {
        await fetch(`/api/prototypes/${chatId}/thumbnail`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ thumbnail: dataUrl }),
        })
      }
    } catch (err) {
      console.warn('thumbnail upload failed', err)
    }
  }, [chatId, iframeRef, loading])

  return { iframeRef, onIframeLoad }
}
